//Insitu Extractor List
export const FETCH_INSITU_EXTRACTOR_LIST_REQUEST = "FETCH_INSITU_EXTRACTOR_LIST_REQUEST";
export const FETCH_INSITU_EXTRACTOR_LIST_SUCCESS = "FETCH_INSITU_EXTRACTOR_LIST_SUCCESS";
export const FETCH_INSITU_EXTRACTOR_LIST_FAILURE = "FETCH_INSITU_EXTRACTOR_LIST_FAILURE";

//Insitu Extractor Details 
export const FETCH_INSITU_EXTRACTOR_DETAILS_REQUEST = "FETCH_INSITU_EXTRACTOR_DETAILS_REQUEST";
export const FETCH_INSITU_EXTRACTOR_DETAILS_SUCCESS = "FETCH_INSITU_EXTRACTOR_DETAILS_SUCCESS";
export const FETCH_INSITU_EXTRACTOR_DETAILS_FAILURE = "FETCH_INSITU_EXTRACTOR_DETAILS_FAILURE";

// POST insitu Extractors
export const POST_INSITU_EXTRACTOR_REQUEST = "POST_INSITU_EXTRACTOR_REQUEST";
export const POST_INSITU_EXTRACTOR_SUCCESS = "POST_INSITU_EXTRACTOR_SUCCESS";
export const POST_INSITU_EXTRACTOR_FAILURE = "POST_INSITU_EXTRACTOR_FAILURE";
export const POST_INSITU_EXTRACTOR_RESET = "POST_INSITU_EXTRACTOR_RESET";


// PUT insitu Extractors
export const PUT_INSITU_EXTRACTOR_REQUEST = "PUT_INSITU_EXTRACTOR_REQUEST";
export const PUT_INSITU_EXTRACTOR_SUCCESS = "PUT_INSITU_EXTRACTOR_SUCCESS";
export const PUT_INSITU_EXTRACTOR_FAILURE = "PUT_INSITU_EXTRACTOR_FAILURE";
export const PUT_INSITU_EXTRACTOR_RESET = "PUT_INSITU_EXTRACTOR_RESET";

// DELETE insitu Extractors
export const DELETE_INSITU_EXTRACTOR_REQUEST = "DELETE_INSITU_EXTRACTOR_REQUEST";
export const DELETE_INSITU_EXTRACTOR_SUCCESS = "DELETE_INSITU_EXTRACTOR_SUCCESS";
export const DELETE_INSITU_EXTRACTOR_FAILURE = "DELETE_INSITU_EXTRACTOR_FAILURE";
